/**
 * @file 登录页面
 * @author wangzhuang
 * */

/* globals ucCommonLogin passport */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './index.less';

const getCookie = name => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
};

class Login extends Component {
    static propTypes = {
        userLoginstate: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        const index = getCookie('loginType') === '5' ? 1 : 0;
        this.state = {
            tabIndex: index || 0, // 0=百度账号，1=推广账号
            ppType: true // true=账号密码 false=短信
        };
    }

    componentWillMount() {
        const params = this.getParams();
        if (this.isPC()) {
            location.href = `/?login=true${params.urlto ? `&urlto=${params.urlto}` : ''}`;
        }
    }

    componentDidMount() {
        const params = this.getParams();
        let passDomain = `wappass${this.isDev() ? '.qatest' : ''}.baidu.com`;
        let url = `//${passDomain}/static/touch/js/api/wrapper.js?cdnversion=${new Date().getTime()}`;
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);

        const getStaticPage = () => {
            if (this.isDev()) {
                return `${location.origin}/console/static/v3Jump.html`;
            }

            return `${location.origin}/upload/sdk/v3Jump.html`;
        };
        script.onload = () => {
            passport.use('login', { // 账号密码
                library: true,
                defaultCss: true
            }, apiMagic => {
                /* eslint-disable-next-line */
                let loginInstance = new apiMagic.passport.login({
                    product: 'spu',
                    staticPage: getStaticPage(),
                    u: params && params.urlto || `${location.origin}/m`
                });
                loginInstance.on('loginSuccess', res => {
                    console.log(res);
                });
                loginInstance.on('loginError', res => {
                    console.log(res);
                });
                loginInstance.render('loginPass');
            });

            passport.use('smsLogin', { // 短信
                library: true,
                defaultCss: true
            }, apiMagic => {
                /* eslint-disable-next-line */
                let loginInstance = new apiMagic.passport.smsLogin({
                    product: 'spu',
                    staticPage: getStaticPage(),
                    u: params && params.urlto || `${location.origin}/m`,
                    overseas: 0,
                    adapter: 3,
                    smsRegTip: 1
                });

                loginInstance.render('ppSmsLogin');
            });
        };

        let passDomain2 = `//cas.baidu.com/staticv2/dep/common-login/${this.isTest()
            ? 'qa-'
            : ''}api.js`;
        let script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src = passDomain2;
        document.getElementsByTagName('head')[0].appendChild(script2);
        script2.onload = () => {
            ucCommonLogin.init({
                container: 'ucLogin',                        // 登录框渲染父节点id
                appid: 592,                                  // 登录产品线 appid
                appscope: [
                    3,
                    22,
                    26,
                    27,
                    28,
                    31,
                    66,
                    67,
                    110,
                    223,
                    285,
                    303,
                    21,
                    129,
                    309,
                    58,
                    151,
                    463,
                    486,
                    406,
                    417,
                    15,
                    377,
                    289,
                    525,
                    592
                ],
                // 登录成功后要跳转的地址，此 url 需要接入 casClient
                fromu: `${location.origin}/user/ucState?redirect_url=${
                    (
                        params && params.urlto && encodeURIComponent(params.urlto)
                        || encodeURIComponent(encodeURIComponent(location.href)
                        ))
                }`,
                product: 'spu',                           // 登录产品线信息
                staticPage: getStaticPage(),  // 登录成功，跳转中转页地址
                // staticPage: `${location.origin}/uc_v3Jump.html`,  // 登录成功，跳转中转页地址
                multiLogin: 0,                             // 是否显示 passport 登录框+uc 登录框，默认0，只显示 uc 登录框
                isSmall: 0,                                // 样式大小控制
                isLayer: 0                             // 浮层样式开启
            });
        };
    }

    render() {
        const {userLoginstate} = this.props;
        if (userLoginstate.status === 0) {
            location.href = '/m';
        }
        let {
            tabIndex,
            ppType
        } = this.state;
        return (
            <div className={'spui-login'}>
                <div className={'login-tab'}>
                    {['百度账号', '百度推广账号'].map((item, index) => {
                        return <div
                            className={tabIndex === index ? 'on' : ''}
                            key={index}
                            onClick={() => {
                                if (tabIndex === index) {
                                    return;
                                }
                                this.setState({
                                    tabIndex: index,
                                    baiduName: '',
                                    baiduPassword: '',
                                    baiduNameOff: false,
                                    baiduPasswordOff: false
                                });
                            }}
                        >
                            {item}
                        </div>;
                    })}
                </div>
                <div className={'login-con'}>
                    {tabIndex === 0
                        ? <div className={'textAlginR'}>
                            <span
                                className={'linkText'}
                                onClick={() => {
                                    this.setState({
                                        ppType: !ppType
                                    });
                                }}
                            >
                                {ppType ? '短信快捷登录' : '用户名密码登录'}
                            </span>
                        </div>
                        : null
                    }

                    <div style={{display: `${tabIndex === 0 ? 'block' : 'none'}`}}>
                        <div id={'loginPass'} style={{display: `${ppType ? 'block' : 'none'}`}}/>
                        <div id={'ppSmsLogin'} style={{display: `${!ppType ? 'block' : 'none'}`}}/>
                    </div>


                    <div id={'ucLogin'} style={{display: `${tabIndex === 1 ? 'block' : 'none'}`}}/>

                    {ppType || tabIndex === 1
                        ? <div className={'login-link'}>
                            {
                                tabIndex === 1
                                    ? <a href="https://aq.baidu.com/new/#/school" target={'_blank'}>
                                        安全控件常见问题
                                    </a>
                                    : <div/>
                            }

                            <div>
                                <a
                                    href={
                                        tabIndex === 0
                                            ? 'https://passport.baidu.com/v2/?reg&u=https%3A//login.bce.baidu.com/'
                                            + '%3Fredirect%3Dhttp%253A%252F%252Fcloud.baidu.com%252F&tpl=bceplat'
                                            : 'https://u.baidu.com/ucweb/?'
                                            + 'module=Reguser&controller=reg&action=index&appid=3#/register'
                                    }
                                    target={'_blank'}
                                >
                                    注册账号
                                </a>
                                <a
                                    href={
                                        tabIndex === 0
                                            ? 'https://passport.baidu.com/?getpassindex&tt=1566373747096&'
                                            + 'gid=530BE4D-70B6-4A52-80B1-DC6D4EE3F2F9&tpl=bceplat&'
                                            + 'u=https%3A%2F%2Flogin.bce.baidu.com%2Fpostlogin%3F_1566373752323%26re'
                                            + 'direct%3Dhttp%253A%252F%252Fcloud.baidu.com%252F'
                                            : 'https://aq.baidu.com/new/#/findpwd'
                                    }
                                    target={'_blank'}
                                >
                                    忘记密码
                                </a>
                            </div>
                        </div>
                        : null
                    }


                    <div className={'login-hint'}>
                        温馨提示：与百度搜索、百度贴吧、百度云盘、百度知道、百度文库等产品通用。
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
    };
}

function mapDispatchToProps() {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login/index.js